import React, { Component } from 'react';
import { withRouter } from 'react-router'

class AuthenticatedArea extends Component {

  render() {
    return (
      <div>
        <div className="authenticated-area">
          {this.props.children}
        </div>     
      </div>
    );
  }
}

export default withRouter(AuthenticatedArea);


// WEBPACK FOOTER //
// ./src/components/auth/AuthenticatedArea.js